/* eslint-disable import/prefer-default-export */
export const SEARCH_FOR_ROUTER = 'SEARCH_FOR_ROUTER';
export const GET_TRACKLIST = 'GET_TRACKLIST';
export const GET_TRACKLIST_BY_CATEGORY = 'GET_TRACKLIST_BY_CATEGORY';
export const GET_TRACKLIST_CATEGORY = 'GET_TRACKLIST_CATEGORY';
export const GET_CLASSIFICATION = 'GET_CLASSIFICATION';
export const GET_PROCUREMENT_RELEASE = 'GET_PROCUREMENT_RELEASE';
export const GET_RETRIEVALS = 'GET_RETRIEVALS';
export const GET_INSTALLATIONS = 'GET_INSTALLATIONS';
